import React from 'react';
import { HeroSection } from './sections/HeroSection';
import { TransformationSection } from './sections/TransformationSection';
import { OfferSection } from './sections/OfferSection';
import { ModulesSection } from './sections/ModulesSection';
import { PreviewSection } from './sections/PreviewSection';
import { GuideSection } from './sections/GuideSection';
import { TestimonialsSection } from './sections/TestimonialsSection';
import { GuaranteeSection } from './sections/GuaranteeSection';
import { FaqSection, FinalSection, Footer } from './sections/ClosingSections';
import { StickyCTA } from './StickyCTA';
export function LandingPage() {
  return <div className="min-h-screen w-full bg-ink font-sans text-ivory" data-id="element-17" data-mp="fxs3jyzfyrb8">
      <HeroSection data-id="element-18" data-mp="azqi57ejmfwl" />
      <main data-id="element-19" data-mp="b08o4vr0c8hp">
        <TransformationSection data-id="element-20" data-mp="awchc3lj2er9" />
        <OfferSection data-id="element-21" data-mp="6xbywm6ype4s" />
        <ModulesSection data-id="element-22" data-mp="6vsj0wp7x53j" />
        <PreviewSection data-id="element-23" data-mp="6w0vinhfi8e7" />
        <GuideSection data-id="element-24" data-mp="1xqzybrsl5s2" />
        <TestimonialsSection data-id="element-25" data-mp="1x7isx9yulf3" />
        <GuaranteeSection data-id="element-26" data-mp="1z22675la5h2" />
        <FaqSection data-id="element-27" data-mp="1ztxrhz6s37c" />
        <FinalSection data-id="element-28" data-mp="2ni72ba43ryvt" />
      </main>
      <Footer data-id="element-29" data-mp="2nh5qv4j6dadk" />
      <StickyCTA triggerId="transformacion" data-id="element-30" data-mp="2ngnp5sdqu3y9" />
    </div>;
}